import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bar-chart-2",
  "use": "icon-bar-chart-2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-bar-chart-2\" id=\"icon-bar-chart-2\"><line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"10\" /><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\" /><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"14\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol